import { Facebook, LinkedIn, Mail } from '@mui/icons-material';
import XIcon from '@mui/icons-material/X';
import { type CSSProperties, Link, Stack, Typography, type SvgIconProps } from '@mui/material';
import { capitalize } from '@cc-shopping/utils/string/capitalize';
import type { ElementType } from 'react';

import { AccessibleHiddenText } from '../../primitives/AccessibleHiddenText';

const SOCIAL_TYPES: Record<string, ElementType<SvgIconProps>> = {
  email: props => <Mail {...props} />,
  facebook: props => <Facebook {...props} />,
  twitter: props => <XIcon {...props} />,
  linkedin: props => <LinkedIn {...props} />,
} as const;

export type SocialMediaLinkType = 'email' | 'facebook' | 'twitter' | 'linkedin';

export interface SocialMediaLinkProps {
  type: SocialMediaLinkType;
  url: string;
  iconOnly?: boolean;
  size?: CSSProperties['fontSize'];
}

export function SocialMediaLink({
  type,
  url,
  iconOnly = false,
  size = 'large',
}: SocialMediaLinkProps) {
  const IconComponent = SOCIAL_TYPES[type];
  const name = capitalize(type);

  return (
    <Link href={url} target="_blank" rel="noopener noreferrer">
      <Stack
        spacing={1}
        direction="row"
        sx={{
          alignItems: 'center',
        }}
      >
        <IconComponent sx={{ fontSize: size }} />
        {!iconOnly ? (
          <Typography component="span" sx={{ display: { xs: 'none', md: 'inline-block' } }}>
            {name}
          </Typography>
        ) : (
          <AccessibleHiddenText>{name}</AccessibleHiddenText>
        )}
      </Stack>
    </Link>
  );
}
